import { Navigate, useOutletContext } from "react-router-dom";

export default function SettingsGuard({ permKey, children }) {
    const { perms } = useOutletContext();

    if (!perms[permKey]) {
        return <Navigate to="/settings/account/profile" replace />;
    }

    return children;
}
